import React from 'react';
import getDefaultContext from './get-default-context';
var SettingsContext = /*#__PURE__*/React.createContext(getDefaultContext('SettingsContext'));
export default SettingsContext;